import { render, staticRenderFns } from "./RelatorioQuebra.vue?vue&type=template&id=926c2f8c&"
import script from "./RelatorioQuebra.vue?vue&type=script&lang=js&"
export * from "./RelatorioQuebra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports